"use strict";

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var player_1 = __importDefault(require("@vimeo/player"));

var VideoOverlay_1 = __importDefault(require("./VideoOverlay"));

var CustomControls_1 = require("./CustomControls");

var react_visibility_sensor_1 = __importDefault(require("react-visibility-sensor"));

var VideoPlayer =
/** @class */
function (_super) {
  __extends(VideoPlayer, _super);

  function VideoPlayer(props) {
    var _this = _super.call(this, props) || this;

    _this.componentDidMount = function () {
      // create inline player directly after Mount
      !_this.props.overlay && setTimeout(function () {
        // short delay needed for Dom ref
        _this.videoContainer && _this.videoContainer.current && _this.createPlayer();
      }, 0);
      window.addEventListener(_this.resizeEvent, function () {
        // short timeout is needed, because it takes a moment
        // until the window size is updated after rotation
        return setTimeout(function () {
          _this.resizeIframe();
        }, 200);
      });
    };

    _this.componentWillUnmount = function () {
      clearTimeout(_this.mouseTimeout);
      clearTimeout(_this.throttleTimeout);

      if (_this.player) {
        _this.player.off('play');

        _this.player.off('pause');

        _this.player.off('loaded');
      }

      window.removeEventListener(_this.resizeEvent, _this.resizeIframe);
    };

    _this.addMouseEventListener = function () {
      window.addEventListener(_this.interactionEvent, _this.throttleMouseMove);
    };

    _this.removeMouseEventListener = function () {
      window.removeEventListener(_this.interactionEvent, _this.throttleMouseMove);
    };

    _this.throttleMouseMove = function () {
      _this.throttle(_this.throttleTimeout, _this.showControls, 150);
    };

    _this.throttle = function (timeout, fn, wait) {
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        fn();
      }, wait);
    };

    _this.handleAutoplay = function (isVisible) {
      isVisible ? _this.player && _this.props.autoPlay && _this.player.play() : _this.player && _this.player.pause();
    };

    _this.showControls = function () {
      //hide controls if user doesn't move the mouse for 1000ms
      _this.setState({
        mouseMoving: true
      });

      clearTimeout(_this.mouseTimeout);
      _this.mouseTimeout = setTimeout(function () {
        return _this.setState({
          mouseMoving: false
        });
      }, 1000);
    };

    _this.createPlayer = function () {
      var _a = _this.props,
          videoId = _a.videoId,
          _b = _a.loop,
          loop = _b === void 0 ? false : _b,
          _c = _a.autoPlay,
          autoPlay = _c === void 0 ? false : _c,
          _d = _a.controls,
          controls = _d === void 0 ? true : _d,
          _e = _a.muted,
          muted = _e === void 0 ? true : _e,
          customControls = _a.customControls,
          overlay = _a.overlay;
      var options = {
        id: videoId,
        loop: loop,
        muted: muted,
        controls: customControls ? false : controls,
        // this weird condition is needed to prevent inline outoplay videos from playing
        // before the visibilit sensor fires and still preserve all other functionalities
        autoplay: !(autoPlay && !overlay),
        // only outopause inline players
        autopause: !autoPlay,
        // this doesn't work correctly ofr other formats than landscape, which is why we need the resizeIframe function.
        // Filed a git issue for this bug: https://github.com/vimeo/player.js/issues/504
        responsive: true
      };
      _this.player = new player_1["default"](_this.videoContainer && _this.videoContainer.current, options);

      _this.player.on('play', function () {
        _this.setState({
          isVideoPlaying: true,
          isLoading: false
        });
      });

      _this.player.on('pause', function () {
        _this.setState({
          isVideoPlaying: false
        });
      });

      _this.player.on('loaded', function () {
        _this.resizeIframe(); // small timeout to make the transition smoother


        setTimeout(function () {
          _this.setState({
            isLoading: false,
            // set state manually to fix the timing issue with custom controlls
            isVideoPlaying: _this.props.autoPlay
          });
        }, 300);
      });
    };

    _this.resizeIframe = function () {
      if (_this.videoContainer && _this.videoContainer.current) {
        var inlinePlayerContainerRef = _this.wrapper && _this.wrapper.current && _this.wrapper.current.getBoundingClientRect();

        _this.videoContainer && _this.videoContainer.current && _this.videoContainer.current.children[0].style.setProperty('padding', (!_this.props.overlay ? inlinePlayerContainerRef.height + 'px' : '100vh') + " 0 0 0");
      }
    };

    _this.isMobile = function () {
      return navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i);
    };

    _this.closeModal = function () {
      _this.player && _this.player.destroy().then(function () {
        return _this.triggerModal();
      })["catch"](function () {
        return _this.triggerModal();
      });
    };

    _this.triggerModal = function () {
      _this.setState({
        modalIsOpen: !_this.state.modalIsOpen
      }, function () {
        if (_this.state.modalIsOpen) {
          // wait until dom ref is initialised and then create player with it
          // needed for iOS autoplay !!!
          setTimeout(function () {
            _this.createPlayer();
          }, 20);
          _this.props.customControls && _this.props.controls && _this.addMouseEventListener(); // toggle class to prevent background scroling also on html element

          document.getElementsByTagName('html')[0].classList.add('ReactModal__Body--open');
        } else {
          _this.props.customControls && _this.props.controls && _this.removeMouseEventListener();
          document.getElementsByTagName('html')[0].classList.remove('ReactModal__Body--open');
        }
      });
    };

    _this.state = {
      isLoading: true,
      mouseMoving: false,
      showcontrols: false,
      isVideoPlaying: false,
      modalIsOpen: false
    };
    _this.videoContainer = react_1["default"].createRef();
    _this.wrapper = react_1["default"].createRef();
    _this.interactionEvent = typeof window !== 'undefined' && _this.isMobile() ? 'click' : 'mousemove';
    _this.resizeEvent = typeof window !== 'undefined' && _this.isMobile() ? 'orientationchange' : 'resize'; // Initial error handling

    if (_this.props.overlay && !_this.props.posterImage) {
      console.warn('Video component: A video player with overlay functionality needs to have a poster image');
    }

    if (_this.props.customControls && typeof _this.props.controls !== 'undefined' && !_this.props.controls) {
      console.warn('Video component: Cannot show custom controls if controls prop is set to "false".');
    }

    return _this;
  }

  VideoPlayer.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        _b = _a.overlay,
        overlay = _b === void 0 ? false : _b,
        _c = _a.controls,
        controls = _c === void 0 ? true : _c,
        _d = _a.customControls,
        customControls = _d === void 0 ? false : _d,
        posterImage = _a.posterImage,
        autoPlay = _a.autoPlay;
    var _e = this.state,
        isLoading = _e.isLoading,
        isVideoPlaying = _e.isVideoPlaying,
        modalIsOpen = _e.modalIsOpen,
        mouseMoving = _e.mouseMoving;
    return overlay ? react_1["default"].createElement(Wrapper, {
      onClick: function onClick() {
        return !modalIsOpen && _this.triggerModal();
      }
    }, react_1["default"].createElement(VideoOverlay_1["default"], {
      closeModal: function closeModal() {
        return _this.closeModal();
      },
      play: function play() {
        return _this.player && _this.player.play();
      },
      pause: function pause() {
        return _this.player && _this.player.pause();
      },
      videoElement: react_1["default"].createElement(VideoElement, {
        ref: this.videoContainer
      }),
      modalIsOpen: !!modalIsOpen,
      posterImage: posterImage,
      isLoading: !!isLoading,
      customControls: customControls,
      controls: controls,
      isVideoPlaying: isVideoPlaying,
      mouseMoving: !!mouseMoving
    })) : react_1["default"].createElement(Wrapper, {
      ref: this.wrapper,
      onMouseEnter: function onMouseEnter() {
        return controls && _this.addMouseEventListener();
      },
      onMouseLeave: function onMouseLeave() {
        return controls && _this.removeMouseEventListener();
      }
    }, autoPlay ? react_1["default"].createElement(react_visibility_sensor_1["default"], {
      offset: {
        bottom: 200
      },
      onChange: this.handleAutoplay,
      partialVisibility: true
    }, react_1["default"].createElement(VideoElement, {
      ref: this.videoContainer
    })) : react_1["default"].createElement(VideoElement, {
      ref: this.videoContainer
    }), this.player && react_1["default"].createElement(CustomControls_1.CustomControls, {
      isVideoPlaying: !!isVideoPlaying,
      mouseMoving: !!mouseMoving,
      isLoading: !!isLoading,
      customControls: customControls,
      controls: controls,
      play: function play() {
        return _this.player && _this.player.play();
      },
      pause: function pause() {
        return _this.player && _this.player.pause();
      }
    }));
  };

  return VideoPlayer;
}(react_1["default"].Component);

exports.VideoPlayer = VideoPlayer;
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  max-width: 100%;\n  max-height: 100%;\n"], ["\n  position: relative;\n  max-width: 100%;\n  max-height: 100%;\n"])));
var VideoElement = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  z-index: 10;\n"], ["\n  text-align: center;\n  z-index: 10;\n"])));
var templateObject_1, templateObject_2;